export const VTMN_TAG_VARIANT = {
  ACCENT: 'accent',
  ALERT: 'alert',
  BRAND: 'brand',
  DECORATIVE_GRAVEL: 'decorative_gravel',
  DECORATIVE_BRICK: 'decorative_brick',
  DECORATIVE_SAFFRON: 'decorative_saffron',
  DECORATIVE_GOLD: 'decorative_gold',
  DECORATIVE_JADE: 'decorative_jade',
  DECORATIVE_EMERALD: 'decorative_emerald',
  DECORATIVE_COBALT: 'decorative_cobalt',
  DECORATIVE_AMETHYST: 'decorative_amethyst',
};

export const VTMN_TAG_SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
};
